import { Provider } from '@angular/core';

import { RegionsService } from '@regions/services/regions.service';
import { REGIONS_STORE } from '@regions/stores/regions.store';

export const REGIONS_PROVIDERS: Provider[] = [RegionsService, REGIONS_STORE];
